export default "__VITE_ASSET__DOhUhiL5__"